!<!-- 特权卡片 -->
<template>
    <div class="privilege-card">
        <veui-tabs
            ui="l"
            :active="active"
            @change="tabsChange"
        >
            <veui-tab label="曝光权益" name="exposure"/>
            <veui-tab label="成员权益" name="member"/>
            <veui-tab label="效果权益" name="effect"/>
            <veui-tab label="工具权益" name="tool"/>
        </veui-tabs>
        <div class="content" :class="{'is-vip': isVip}">
            <!-- 已解锁权益 -->
            <div v-if="cardListShow && cardListShow.unLockList" class="content-box">
                <div class="title">已解锁</div>
                <div
                    class="cards"
                >
                    <div
                        v-for="item in cardListShow.unLockList"
                        :key="item.title"
                        class="card-item"
                    >
                        <div class="icon" :style="{backgroundImage: `url(${item.icon})`}"></div>
                        <div class="card-title">{{ item.title }}</div>
                        <div class="card-subtitle">{{ item.subtitle }}</div>
                    </div>
                </div>
            </div>
            <!-- 待解锁权益 -->
            <div v-if="cardListShow && cardListShow.lockList" class="content-box">
                <div class="title">待解锁</div>
                <div class="cards">
                    <div
                        v-for="item in cardListShow.lockList"
                        :key="item.title"
                        class="card-item"
                    >
                        <div class="icon" :style="{backgroundImage: `url(${item.icon})`}"></div>
                        <div class="card-title">{{ item.title }}</div>
                        <div class="card-subtitle">{{ item.subtitle }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Tabs,
    Tab
} from 'veui';
import {mapState} from 'vuex';
import {cardList, vipCardList} from '../table.js';
export default {
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore.vipInfo || {}
        }),
        isVip() {
            return !!(this.vipInfo && +this.vipInfo.vipStatus);
        }
    },
    data() {
        return {
            active: 'exposure',
            cardList: [], // 用户全部权益列表
            cardListShow: [] // 当前展示的
        };
    },
    watch: {
        isVip: {
            handler(val) {
                this.cardList = val ? vipCardList : cardList;
                this.cardListShow = this.cardList[this.active] || [];
            },
            immediate: true
        }
    },
    methods: {
        tabsChange(data) {
            if (this.active !== data.name) {
                this.active = data.name;
                this.cardListShow = this.cardList[this.active] || [];
            }
        }
    }
};
</script>

<style lang='less' scoped>
.privilege-card {
    background: #fff;
    border-radius: 8px;
    padding: 12px 30px 30px;
    margin-top: 24px;

    .content {
        .content-box {
            .title {
                font-size: 16px;
                font-weight: 500;
                line-height: 1;
                color: #333;
                padding: 18px 0;
            }

            .cards {
                display: grid;
                grid-template-columns: repeat(5, 202px);
                gap: 15px 15px;

                .card-item {
                    width: 202px;
                    height: 232px;
                    border: 1px solid #e0ebff;
                    background: linear-gradient(46.03deg, #f7faff 3.09%, #f3f7ff 98.16%);
                    border-radius: 8px;
                    padding: 40px 14px 0;
                    text-align: center;

                    .icon {
                        width: 60px;
                        height: 60px;
                        margin: 0 auto;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }

                    .card-title {
                        color: #1e1f24;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 1;
                        padding: 20px 0 12px;
                    }

                    .card-subtitle {
                        color: #848691;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 22px;
                    }
                }
            }
        }

        &.is-vip {
            .card-item {
                border: 1px solid #ffe6d1 !important;
                background: linear-gradient(46.03deg, #fffbf7 3.09%, #fff9f3 98.16%) !important;
            }
        }
    }
}
</style>
